import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { FullscreenModalHeader } from '../../../components/fullscreen/FullscreenModalHeader';
import { MultiChannelLayout } from './MultiChannelLayout';
import { SingleResourceLayout } from './SingleResourceLayout';
import { s } from './styles';
import { IAIScheduleSuccessProps } from './types';
import { useCampaignSession } from './useCampaignSession';

export type { IAIScheduleSuccessProps } from './types';

const AIScheduleSuccessBase: React.FC<IAIScheduleSuccessProps> = props => {
	const { className, styles = [], hideHeader = false } = props;
	const { session, primaryResource, secondaryResources, handleGenerateResource, handleClose } =
		useCampaignSession(props);

	// If there are no secondary resources available (due to feature flags), show single resource layout
	const hasAvailableSecondaryResources = secondaryResources && secondaryResources.length > 0;

	return (
		<>
			{/* Conditionally render header - hide when used within other modal contexts */}
			{!hideHeader && (
				<FullscreenModalHeader onRequestClose={handleClose} onRequestBack={handleClose}>
					Success
				</FullscreenModalHeader>
			)}

			<div className={`${css(s.container, ...styles)} unified-schedule-success ${className || ''}`}>
				{session && primaryResource && hasAvailableSecondaryResources ? (
					<>
						<h2 className={css(s.whatNextTitle)}>What Next?</h2>
						<MultiChannelLayout
							primaryResource={primaryResource}
							secondaryResources={secondaryResources}
							onGenerateResource={handleGenerateResource}
							onClose={handleClose}
							props={props}
						/>
					</>
				) : (
					<>
						<h2 className={css(s.whatNextTitle)}>What Next?</h2>
						<SingleResourceLayout props={props} onClose={handleClose} />
					</>
				)}
			</div>
		</>
	);
};

const AIScheduleSuccess = observer(AIScheduleSuccessBase);

export { AIScheduleSuccess };
